import type {LitElement} from 'lit';
import type React from 'react';

interface KilnPluginDefinition {
  beforeRender?: (host: LitElement) => void;
  render?: (root: React.ReactNode, host: LitElement) => React.ReactNode;
  afterRender?: (host: LitElement) => void;
  disconnect?: (host: LitElement) => void;
}

// TODO(joshua): Create more sophisticated plugin logic.
export interface KilnPlugin extends KilnPluginDefinition {
  __plugin__: true;
}

export function createKilnPlugin(def: () => KilnPluginDefinition): KilnPlugin {
  // TODO(joshua): Add additional logic;
  return {...def(), __plugin__: true};
}
